import { render, staticRenderFns } from "./FreeRegisterForm.vue?vue&type=template&id=40e8bfae&lang=pug&"
import script from "./FreeRegisterForm.vue?vue&type=script&lang=js&"
export * from "./FreeRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports